import { createFileRoute } from "@tanstack/react-router";
import { Mail, MessageCircle } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { SiteFooter } from "@/components/SiteFooter";
import { useI18n } from "@/lib/i18n";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/contact")({
  head: () => pageHead({
    path: "/contact",
    title: "Contact — Book Swap",
    description: "Get in touch with the Book Swap team for account support, privacy requests, safety concerns or product feedback.",
  }),
  component: Contact,
});

function Contact() {
  const { lang } = useI18n();
  const isAr = lang === "ar";

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="mx-auto max-w-2xl px-4 py-12" dir={isAr ? "rtl" : "ltr"}>
        <h1 className="font-serif text-3xl md:text-4xl">{isAr ? "تواصل معنا" : "Contact us"}</h1>
        <p className="mt-3 text-muted-foreground">
          {isAr
            ? "نحن هنا للإجابة على أسئلتك حول الحساب، الخصوصية، أو الدعم العام."
            : "We're here to help with account questions, privacy requests, or general support."}
        </p>

        <div className="mt-8 grid gap-4">
          <a href="mailto:z3phyr11@outlook.com" className="flex items-center gap-4 rounded-2xl border border-border bg-card p-5 shadow-sm hover:border-primary/40">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-soft text-primary"><Mail className="h-5 w-5" /></div>
            <div>
              <p className="font-semibold">{isAr ? "البريد الإلكتروني" : "Email"}</p>
              <p className="text-sm text-muted-foreground">z3phyr11@outlook.com</p>
            </div>
          </a>
          <a href="mailto:z3phyr11@outlook.com" className="flex items-center gap-4 rounded-2xl border border-border bg-card p-5 shadow-sm hover:border-primary/40">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-soft text-primary"><MessageCircle className="h-5 w-5" /></div>
            <div>
              <p className="font-semibold">{isAr ? "طلبات الخصوصية" : "Privacy requests"}</p>
              <p className="text-sm text-muted-foreground">z3phyr11@outlook.com</p>
            </div>
          </a>
        </div>

        <p className="mt-8 text-sm text-muted-foreground">
          {isAr
            ? "نرد عادةً خلال يوم أو يومي عمل."
            : "We typically respond within 1–2 business days."}
        </p>
      </div>
      <SiteFooter />
    </div>
  );
}
